// extracted by mini-css-extract-plugin
export var container = "About-module--container--ZLL9c";
export var verticalCenter = "About-module--verticalCenter--3OL74";
export var title = "About-module--title--3WYSi";
export var text = "About-module--text--GuEwX";
export var shapeWrapper = "About-module--shapeWrapper--3eydB";